import React from "react";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { connect } from "react-redux";
import { setcheckBoxAnswerChoice } from "../state/domains";
import Box from "@mui/material/Box";

const CheckboxChoices = props => {
  const { card, _setAnswerChoice } = props;
  const { question, qnId, choices } = card;
  let i = 0;
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        md={5}
        sx={{ "padding-top": "2vh", "padding-bottom": "2vh" }}>
        <Box
          sx={{
            display: "flex",
            fontWeight: "bold",
            boxShadow: 1,
            borderRadius: 2,
            "background-color": "#e7ede0",
            p: 1,
          }}>
          {" "}
          {question}:{" "}
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ "padding-bottom": "2vh", "padding-left": "3vh" }}>
        <FormGroup row>
          {choices.map(({ choice, option, selected }) => {
            ++i;
            return (
              <FormControlLabel
                control={
                  <Checkbox
                    key={`${qnId}-check-${i}`}
                    checked={selected}
                    name={`${qnId}-check-${i}`}
                    onChange={e => {
                      _setAnswerChoice(qnId, option, e.target.checked);
                    }}
                    value={option}
                  />
                }
                label={choice}
              />
            );
          })}
        </FormGroup>
      </Grid>
    </Grid>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    _setAnswerChoice: (questionId, choice, value) =>
      dispatch(setcheckBoxAnswerChoice(questionId, choice, value)),
  };
}

export default connect(null, mapDispatchToProps)(CheckboxChoices);
